const TrackerTakeoverHistoryModal = ({
  isOpen,
  loading,
  ticketNumber,
  rows,
  queryDebug,
  onRefresh,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[145] flex items-center justify-center bg-black/45 px-4">
      <div className="max-h-[95vh] w-full max-w-4xl overflow-y-auto rounded-2xl border border-slate-200 bg-white shadow-2xl">
        <div className="sticky top-0 z-10 border-b border-slate-200 bg-white px-6 py-4">
          <div className="flex items-start justify-between gap-3">
            <div>
              <h3 className="text-lg font-semibold text-slate-900">Take Over History</h3>
              <p className="text-sm text-slate-600">
                Ticket <span className="font-semibold text-slate-900">#{ticketNumber || "-"}</span>
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={onRefresh}
                disabled={loading}
                className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-100 disabled:opacity-70"
              >
                Refresh
              </button>
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-100"
              >
                Close
              </button>
            </div>
          </div>
        </div>

        <div className="space-y-3 px-6 py-5">
          {loading ? (
            <p className="text-sm text-slate-600">Loading takeover history...</p>
          ) : rows.length === 0 ? (
            <p className="text-sm text-slate-600">No takeover history found for this ticket.</p>
          ) : (
            <div className="overflow-x-auto rounded-xl border border-slate-200">
              <table className="min-w-full divide-y divide-slate-200 bg-white text-sm">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="px-3 py-2 text-left font-semibold text-slate-700">Date/Time</th>
                    <th className="px-3 py-2 text-left font-semibold text-slate-700">Status Source</th>
                    <th className="px-3 py-2 text-left font-semibold text-slate-700">Created By</th>
                    <th className="px-3 py-2 text-left font-semibold text-slate-700">Previous Owner</th>
                    <th className="px-3 py-2 text-left font-semibold text-slate-700">Taken Over By</th>
                    <th className="px-3 py-2 text-left font-semibold text-slate-700">Remarks</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {rows.map((item) => (
                    <tr key={item.id}>
                      <td className="px-3 py-2 text-slate-700">{item.created_at || "-"}</td>
                      <td className="px-3 py-2 text-slate-700 capitalize">{item.source_status || "-"}</td>
                      <td className="px-3 py-2 text-slate-700">{item.created_by_name || "-"}</td>
                      <td className="px-3 py-2 text-slate-700">{item.previous_owner_name || "-"}</td>
                      <td className="px-3 py-2 text-slate-700">{item.taken_over_by_name || "-"}</td>
                      <td className="px-3 py-2 text-slate-700">{item.remarks || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {queryDebug?.resolved ? (
            <details className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700">
              <summary className="cursor-pointer font-semibold text-slate-800">
                Takeover History API Debug Query (Resolved)
              </summary>
              <pre className="mt-2 overflow-x-auto whitespace-pre-wrap">{queryDebug.resolved}</pre>
            </details>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default TrackerTakeoverHistoryModal;

